import { createUseStyles } from 'react-jss';
import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  {
    root: {
      height: 40,
      [BreakPointsMedia.SM]: {
        height: 32,
      },
      [BreakPointsMedia.XS]: {
        height: 32,
      },
      [BreakPointsMedia.XXS]: {
        height: 32,
      },
    },
  },
  {
    name: 'top-navigation',
  },
);
export default useStyles;
